import { supabase } from './supabase';

/** The services a client can buy: one `service_*` boolean on `clients` each. */
export type ServiceField = 'service_google_ads' | 'service_seo';

export type ClientServices = Record<ServiceField, boolean>;

export const SERVICES: { field: ServiceField; label: string }[] = [
  { field: 'service_google_ads', label: 'Google Ads' },
  { field: 'service_seo', label: 'SEO' },
];

export async function fetchClientServices(clientId: string): Promise<ClientServices> {
  const { data, error } = await supabase.from('clients').select('service_google_ads, service_seo').eq('id', clientId).single();
  if (error) throw error;
  return data;
}

export async function setClientService(clientId: string, field: ServiceField, value: boolean): Promise<void> {
  // Patch typed per field: a computed key would widen to `{ [x: string]: boolean }`.
  const patch = field === 'service_google_ads' ? { service_google_ads: value } : { service_seo: value };
  const { error } = await supabase.from('clients').update(patch).eq('id', clientId);
  if (error) throw error;
}
